import { PropsWithChildren } from 'react';
import Markdown, { type Options as MarkdownOptions } from 'react-markdown';

import { defaultMarkdownConfig } from './markdownConfig';

type P = PropsWithChildren<{
  children: string | null;
  config?: MarkdownOptions;
}>;

/**
 * Renders Markdown text using a specified configuration.
 *
 * @param children - The Markdown content to render.
 * @param config - The configuration options for rendering Markdown.
 * @returns The rendered Markdown content.
 */
export const MarkdownRenderer = ({
  children,
  config = defaultMarkdownConfig,
}: P) => <Markdown {...config}>{children ?? ''}</Markdown>;
